/* eslint-disable no-mixed-operators */
import { Component } from 'react';
import './Error500.scss'; // Import your SCSS for styling
import Helper from '../../../core/libraries/Helper';
import Constants from '../../../core/libraries/Constants';
import { SupportEmailTemplate } from '../../../core/libraries/Template';

interface Error500Props {
  message?: string;
  showAskForHelp?: boolean
}

class Error500 extends Component<Error500Props> {

  render() {
    const { message, showAskForHelp } = this.props
    return (
      <div className="error-page">
        <div className="error-container">
          <h2 className="error-subtitle">Oops!</h2>
          <p className="error-message">
            {!!message && message || "Something went wrong while connecting to the Expert Search service."}
          </p>
          {!!showAskForHelp && <button className="error-button">
            Ask For Help
          </button>}
        </div>
      </div>
    );
  }
}

export default Error500;
